import { PaymentRouting } from './PaymentRouting';

export const PaymentModule = () => {
  return <PaymentRouting />;
};
